export const feed_show_full_date = 'feed_show_full_date';
